export function hasValue<T>(candidate: T | undefined | null): candidate is T {
  return candidate !== undefined && candidate !== null;
}
